'use client';

import React from 'react';
import dynamic from 'next/dynamic';

const GeneralForm = dynamic(
  () =>
    import('@/components/contact-form/general').then((m) => ({
      default: m.GeneralForm,
    })),
  { ssr: false }
);

const PropertyManagementForm = dynamic(
  () =>
    import('@/components/contact-form/property-management').then((m) => ({
      default: m.PropertyManagementForm,
    })),
  { ssr: false }
);

const EmploymentForm = dynamic(
  () =>
    import('@/components/contact-form/employment').then((m) => ({
      default: m.EmploymentForm,
    })),
  { ssr: false }
);

const WalkInPropertyManagementForm = dynamic(
  () =>
    import('@/components/contact-form/walk-in-property-management-form').then(
      (m) => ({
        default: m.WalkInPropertyManagementForm,
      })
    ),
  { ssr: false }
);

const RealtorReferralForm = dynamic(
  () =>
    import('@/components/contact-form/realtor-referral').then((m) => ({
      default: m.RealtorReferralForm,
    })),
  { ssr: false }
);

type ContactFormClientProps = {
  contactFormType: string | null | undefined;
  brandKey: string;
  /** CMS-configured CTA label (`field_button_text` / GraphQL `buttonText` when available). */
  buttonLabel?: string | null;
};

const DEFAULT_MANAGEMENT_BUTTON_LABEL = 'Submit inquiry';

export const ContactFormClient: React.FC<ContactFormClientProps> = ({
  contactFormType,
  brandKey,
  buttonLabel,
}) => {
  const cmsButtonLabel = buttonLabel?.trim() || null;
  const managementButtonLabel =
    cmsButtonLabel || DEFAULT_MANAGEMENT_BUTTON_LABEL;

  if (contactFormType === 'general') {
    return (
      <GeneralForm
        brandKey={brandKey}
        buttonLabel={cmsButtonLabel || 'Get in Touch'}
      />
    );
  }
  if (contactFormType === 'property_management') {
    return <PropertyManagementForm buttonLabel={managementButtonLabel} />;
  }
  if (contactFormType === 'employment') {
    return (
      <EmploymentForm
        brandKey={brandKey}
        buttonLabel={cmsButtonLabel || 'Submit Application'}
      />
    );
  }
  if (contactFormType === 'walk_in_property_management') {
    return <WalkInPropertyManagementForm buttonLabel={managementButtonLabel} />;
  }
  if (contactFormType === 'realtor_referral') {
    return <RealtorReferralForm buttonLabel={managementButtonLabel} />;
  }
  return null;
};
